import React from "react";
import { ComponentDataDTO } from "groopit-js/client";
import { FlagIcon } from "../Icons/FlagIcon";

interface FollowUpRequestProps {
  component: ComponentDataDTO;
  hasFollowUpFields: boolean;
  openEditor: (anchor: HTMLElement) => void;
}

export const FollowUpRequest = (props: FollowUpRequestProps): JSX.Element => {
  return (
    <>
      {!props.component.model.required && (
        <div className="text-display-normal btn-groopit">
          {props.component.model.description}
        </div>
      )}
      {!props.hasFollowUpFields && (
        <div
          className="text-display-subtitle app-gray-03 pt-4 pb-2 cursor-pointer"
          onClick={(e) => props.openEditor(e.currentTarget)}
        >
          <FlagIcon className="menu-icon" />
          Mark follow-up complete
        </div>
      )}
    </>
  );
};
